module.exports = "/images/scheduling_icon_black.svg?d6f281bfda9009811f24768537ac7279";